import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BRAND_NAME } from "@/config";
import { scrollToWaitlist } from "@/components/landing/Reveal";

const LINKS = [
  { label: "Built for", href: "#built-for" },
  { label: "Why", href: "#why" },
  { label: "Demo", href: "#demo" },
  { label: "QuestionGod", href: "#questiongod" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-sage/85 backdrop-blur-xl border-b border-ink/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-serif text-xl md:text-2xl font-semibold tracking-tight text-ink"
        >
          {BRAND_NAME}
          <span className="text-green">.</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-ink/70 hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          onClick={scrollToWaitlist}
          data-testid="nav-waitlist-btn"
          className="group inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-sage hover:bg-green-dark transition-colors duration-300"
        >
          Join the waitlist
        </button>
      </div>
    </motion.header>
  );
};
